export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {
    console.log('pippo')
    
    jQuery(window).load(function(){        
        var $grid = jQuery('.tm_grid').isotope({
            itemSelector: '.grid-item',
            // options
          });
        // filter items on button click
        jQuery('.filter-button-group').on( 'click', 'button', function() {

          var filterValue = jQuery(this).attr('data-filter');
          console.log(filterValue)
          jQuery('.filter-button-group button').removeClass('filter-active')
          jQuery(this).addClass('filter-active');
          $grid.isotope({ filter: filterValue });
        });
    
   


      

 });
     

  },
};


// WEBPACK FOOTER //
// ./scripts/routes/filters.js